export const VITE_APPLICATION_VERSION = import.meta.env
  .VITE_APPLICATION_VERSION;
export const VITE_BUILD_NUMBER = import.meta.env.VITE_BUILD_NUMBER;
